import { ChangeDetectionStrategy, Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges, SimpleChange } from '@angular/core';
import { FileUploader } from 'ng2-file-upload';
import { environment } from './../../../environments/environment';

@Component({
  selector: 'app-upload',
  templateUrl: './upload.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./upload.component.scss']
})
export class UploadComponent implements OnInit, OnChanges {

  @Input() url: string;
  @Output() onUploadComplete = new EventEmitter();

  readonly baseUrl = environment.serviceURL;
  token = localStorage.getItem('token');

  uploader:FileUploader;

  hasBaseDropZoneOver = false;
  hasAnotherDropZoneOver = false;

  constructor() { }

  ngOnInit() {

    this.uploader = new FileUploader({
        url: this.baseUrl+this.url,
        authToken: this.token
    });

    this.uploader.onAfterAddingFile = f => {
        if (this.uploader.queue.length > 1) {
            this.uploader.removeFromQueue(this.uploader.queue[0]);
        }
        document.querySelector('#upoad-file')['value'] = null;
    };

    this.uploader.onCompleteItem = (item: any, response: any, status: any, headers: any) => {
       //console.log('ImageUpload:uploaded:', item, status, response);
       this.uploader.removeFromQueue(this.uploader.queue[0]);
       this.onUploadComplete.emit(JSON.parse(response));
       return { item, response, status, headers };
    };
  }

  ngOnChanges(changes: SimpleChanges) {
      for (let property in changes) {
          if (property === 'url') {
            if(this.uploader){
              this.uploader.setOptions({
                url:this.baseUrl+changes[property].currentValue,
                authToken: this.token
              });
            }
          }
      }
  }

  fileOverBase(e: any): void {
    this.hasBaseDropZoneOver = e;
  }

  fileOverAnother(e: any): void {
    this.hasAnotherDropZoneOver = e;
  }

  onFileSelectClick(e: any) {
    console.log(e);
      e.target.value = null;
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/upload/upload.component.ts